<template>
  <div>
    <v-select
      outlined
      v-model="cost"
      :items="state.costs"
      item-text="name"
      item-value="name"
      :menu-props="{ maxHeight: '400', zIndex: 13 }"
      label="Coût"
    ></v-select>
  </div>
</template>

<script>
import {
  computed,
  onMounted,
  reactive,
  set,
  watch,
} from "@vue/composition-api";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";
import useQueryString from "@/hooks/useQueryString";

import { URL_PARAM_NAMES } from "@/utils/constants";

const COMPONENT_NAME = "CostFilter";

export default {
  name: COMPONENT_NAME,
  setup(props, { emit }) {
    const { store } = useProxy();
    const { axiosGet } = useAxios();

    const { addQueryStringParam, synchronizeFilterWithQueryString } =
      useQueryString();

    const state = reactive({
      costs: [],
    });

    // =>  METHODS

    // =>  COMPUTED
    const cost = computed({
      get: () => store.getters["marmiton/getCost"],
      set(e) {
        store.dispatch("marmiton/updateCost", e);
      },
    });

    // =>  WATCH
    watch(cost, (newValue) => {
      addQueryStringParam({
        param: URL_PARAM_NAMES[COMPONENT_NAME],
        value: newValue,
        // is_multiple: false,
        // is_integer: false,
        // is_boolean: false,
      });
    });

    // =>  HOOKS
    onMounted(async () => {
      const { data } = await axiosGet("/regie/marmiton/costs");
      set(state, "costs", data);

      await synchronizeFilterWithQueryString({
        dispatcher: "marmiton/updateCost",
        param: URL_PARAM_NAMES[COMPONENT_NAME],
        value: cost.value,
        // is_multiple: false,
        // is_integer: false,
        // is_boolean: false,
        // dependsOn: undefined,
      });
    });

    // =>  DATA
    return {
      state,
      cost,
    };
  },
};
</script>

<style></style>
